<template>
  <div/>
</template>

<script setup lang="ts">
import { AxiosError } from 'axios';
import { inviteGroup } from "~/composables/php/auth";

definePageMeta({
  layout: 'main',
})

const authStore = useAuthStore();
const route = useRoute();
const router = useRouter();


onMounted(async () => {
  /**
   * 로그인이 되어있지 않다면 로그인 페이지로 이동
   * 로그인 후에는 invite 코드를 이용하여 그룹에 가입
   */
  if (authStore.isLogin == false) {
    const next_url = encodeURIComponent(router.currentRoute.value.fullPath);
    await router.push({ name: 'login', query: { next_url } });
    return;
  }

  const code = route.query && route.query.code;
  if (!code) {
    ElMessage.warning('잘못된 요청입니다.');
    await router.push({ name: 'index' });
    return;
  }
  try {
    const response = await inviteGroup({ code });
    const { no } = response.data;
    await router.push({ 
      name: 'room-roomId',
      params: { roomId: no },
      query: { status: 'join' },
    });
  } catch (e) {
    console.error(e);
    let message;
    if (e instanceof AxiosError) {
      message = e.response && e.response.data && e.response.data['message'];
    }
    ElMessage.warning(message || '잘못된 요청입니다.');
    await router.push({ name: 'index' });
  }
});

</script>